// extracted by mini-css-extract-plugin
export default {"container":"FilterIcon_container__GGnxC","icon":"FilterIcon_icon__2MhBZ","indicator":"FilterIcon_indicator__PD9cn"};